import { queryOptions } from '@tanstack/react-query';
import { entryTabsQueryFunction } from '@/modules/FileDetail/queries/entryTabs/entryTabsQueryFunction.ts';

export const entryTabsQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['entry_tabs', id],
    queryFn: () => entryTabsQueryFunction(id),
    enabled: !!id,
  });
